import React from 'react'
import Chart, { Props } from 'react-apexcharts'
import { merge } from 'lodash'
import { defaultTypography, ptBr } from './types/index'
import { ChartLineOptions, ChartLineSeries, ChartLineThemes, themes } from './types/ChartLine'

type ChartLineProps = {
  options: ChartLineOptions
  series: ChartLineSeries[]
  theme?: ChartLineThemes
  height?: number
  type?: Props['type']
}

const ChartLine = ({ options, series, theme = ChartLineThemes.default, height = 740, type = 'line' }: ChartLineProps): JSX.Element => {
  const defaultOptions = {
    colors: themes[theme].seriesColors,
    chart: {
      type: 'line',
      toolbar: {
        show: false
      },
      zoom: {
        enabled: false
      },
      locales: [ptBr],
      defaultLocale: 'pt-br',
      ...defaultTypography
    },
    tooltip: {
      style: {
        ...defaultTypography
      }
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      curve: 'smooth'
    },
    grid: {
      row: {
        colors: ['#f3f3f3', 'transparent'],
        opacity: 0.5
      }
    },
    xaxis: {
      labels: {
        datetimeUTC: false,
        style: {
          colors: ['#4B4B4B'],
          ...defaultTypography
        }
      }
    },
    noData: {
      text: 'No data found :(',
      style: {
        fontSize: '12pt',
        fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
        color: '#4B4B4B',
        fontWeight: 400
      }
    }
  }
  return (
    <Chart options={merge(defaultOptions, options)} series={series} type={type} height={height} />
  )
}

export default ChartLine
